import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import AboutComponent, { StyledP } from
  '@fuww/library/src/Articles/Sections/About';
import { BaseGrid, GridCell } from '@fuww/library/src/Grid';
import Button from '@fuww/library/src/Button';
import messages from '../../../lib/messages.json';

const CallToAction = ({ intl }) => (
  <>
    <Button
      variant="contained"
      href={intl.formatMessage(messages['newsletterCategory.href'], {
        category: 'executive',
      })}
      className="executive-newsletter-signup"
      role="link"
    >
      {intl.formatMessage(messages.signup)}
    </Button>
    <Button
      href="/rss-executive"
      role="link"
    >
      {intl.formatMessage(messages.rssFeed)}
    </Button>
  </>
);

CallToAction.propTypes = {
  intl: PropTypes.shape({ formatMessage: PropTypes.func.isRequired })
    .isRequired,
};

const About = ({
  title,
  description,
}) => {
  const intl = useIntl();

  return (
    <AboutComponent
      title={title}
      description={(
        <BaseGrid>
          <GridCell>
            <StyledP>
              {description}
            </StyledP>
          </GridCell>
        </BaseGrid>
      )}
      callToAction={<CallToAction intl={intl} />}
    />
  );
};

About.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

About.defaultProps = {
  title: null,
  description: null,
};

export default About;
